'use client';

import React, { useState, useEffect } from "react";

function AnimatedLogo({ className, height = "96", width = "107" }) {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prevStep) => (prevStep + 1) % 9); // Loop through 9 steps
    }, 300); // Change step every second
    return () => clearInterval(interval);
  }, []);

  const getOpacity = (index) => {
    if (currentStep === 4 || currentStep === 7) return 20; // When all are 10% opacity
    if (currentStep === 5 || currentStep === 6) {
      return index <= currentStep - 1 ? 100 : 20; // Fade in one by one, then all visible
    }
    return currentStep === index ? 100 : 20; // Individual opacity based on step
  };

  return (
    <div className={className}>
      <svg
        width={height}
        height={width}
        viewBox="0 0 96 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_570_3148)">
          <path
            className="transition-all duration-700"
            d="M25.5166 53.6282C25.446 60.3348 23.8937 66.7196 21.1989 72.8887C17.0183 82.4608 12.2072 91.6978 5.61094 99.9939C4.44651 101.458 3.16766 102.845 1.87827 104.212C1.5967 104.511 0.915895 104.814 0.64487 104.685C0.321101 104.529 0.0322259 103.884 0.0865929 103.498C0.459859 100.874 0.599424 98.164 1.43116 95.6694C3.28208 90.1185 5.50707 84.6832 7.55679 79.1928C10.9543 70.0915 13.4852 60.8429 13.0114 51.0451C12.7103 44.824 11.3755 38.7937 9.30628 32.9295C7.31417 27.2824 4.90335 21.7703 2.93153 16.117C1.74519 12.7164 1.03679 9.1629 0.142576 5.67149C0.0159912 5.17892 -0.0473022 4.63051 0.0419579 4.13794C0.163675 3.46386 0.459854 2.8177 0.681379 2.15991C1.23885 2.47485 1.96915 2.66644 2.32781 3.1241C5.22956 6.82573 8.34796 10.4102 10.8513 14.3492C15.4441 21.5748 19.434 29.1309 22.4558 37.1012C24.0974 41.4319 25.0565 45.9278 25.2618 50.5525C25.3072 51.5788 25.429 52.6027 25.5158 53.6274L25.5166 53.6282Z"
            fill="#96ea6355"
            style={{ opacity: getOpacity(0) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M25.5166 53.6282C25.446 60.3348 23.8937 66.7196 21.1989 72.8887C17.0183 82.4608 12.2072 91.6978 5.61094 99.9939C4.44651 101.458 3.16766 102.845 1.87827 104.212C1.5967 104.511 0.915895 104.814 0.64487 104.685C0.321101 104.529 0.0322259 103.884 0.0865929 103.498C0.459859 100.874 0.599424 98.164 1.43116 95.6694C3.28208 90.1185 5.50707 84.6832 7.55679 79.1928C10.9543 70.0915 13.4852 60.8429 13.0114 51.0451C12.7103 44.824 11.3755 38.7937 9.30628 32.9295C7.31417 27.2824 4.90335 21.7703 2.93153 16.117C1.74519 12.7164 1.03679 9.1629 0.142576 5.67149C0.0159912 5.17892 -0.0473022 4.63051 0.0419579 4.13794C0.163675 3.46386 0.459854 2.8177 0.681379 2.15991C1.23885 2.47485 1.96915 2.66644 2.32781 3.1241C5.22956 6.82573 8.34796 10.4102 10.8513 14.3492C15.4441 21.5748 19.434 29.1309 22.4558 37.1012C24.0974 41.4319 25.0565 45.9278 25.2618 50.5525C25.3072 51.5788 25.429 52.6027 25.5158 53.6274L25.5166 53.6282Z"
            fill="url(#paint0_linear_570_3148)"
            style={{ opacity: getOpacity(0) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M8.23935 106.277C15.0336 99.5584 20.2796 91.8969 25.3942 84.1896C28.9183 78.8791 32.0895 73.3096 34.9003 67.6222C39.769 57.7709 39.2465 47.7985 34.3932 38.0364C28.0931 25.3654 19.7838 13.9254 10.621 3.02297C10.173 2.49007 9.6253 2.03473 9.1287 1.53906C8.51199 0.923937 8.62154 0.48722 9.48898 0.253735C11.8893 -0.393196 13.9836 0.208745 15.613 1.92459C18.2364 4.68684 20.872 7.4553 23.2666 10.396C29.3581 17.8752 35.3474 25.4313 41.3205 32.9982C43.9537 36.3337 46.0756 39.9702 47.688 43.8626C50.554 50.7842 50.098 57.6018 47.0404 64.3697C44.5769 69.8221 40.8969 74.536 37.3006 79.3011C30.6767 88.0773 23.5189 96.4448 16.0212 104.549C14.0883 106.637 10.9991 107.384 8.24016 106.277L8.23935 106.277Z"
            fill="#96ea6355"
            style={{ opacity: getOpacity(1) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M8.23935 106.277C15.0336 99.5584 20.2796 91.8969 25.3942 84.1896C28.9183 78.8791 32.0895 73.3096 34.9003 67.6222C39.769 57.7709 39.2465 47.7985 34.3932 38.0364C28.0931 25.3654 19.7838 13.9254 10.621 3.02297C10.173 2.49007 9.6253 2.03473 9.1287 1.53906C8.51199 0.923937 8.62154 0.48722 9.48898 0.253735C11.8893 -0.393196 13.9836 0.208745 15.613 1.92459C18.2364 4.68684 20.872 7.4553 23.2666 10.396C29.3581 17.8752 35.3474 25.4313 41.3205 32.9982C43.9537 36.3337 46.0756 39.9702 47.688 43.8626C50.554 50.7842 50.098 57.6018 47.0404 64.3697C44.5769 69.8221 40.8969 74.536 37.3006 79.3011C30.6767 88.0773 23.5189 96.4448 16.0212 104.549C14.0883 106.637 10.9991 107.384 8.24016 106.277L8.23935 106.277Z"
            fill="url(#paint1_linear_570_3148)"
            style={{ opacity: getOpacity(1) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M21.8459 2.9707C24.4847 3.79682 27.0611 4.66405 29.0532 6.54589C33.8107 11.0411 38.4822 15.6223 43.312 20.0453C48.7235 25.0013 54.2674 29.8261 59.7617 34.6998C63.9561 38.4208 67.9322 42.3109 70.5962 47.2397C72.8463 51.4021 72.8138 55.5505 70.5069 59.6804C68.2624 63.6977 65.2576 67.155 61.822 70.274C55.7052 75.8273 49.5212 81.3138 43.4248 86.8879C38.2339 91.6336 33.224 96.564 27.9237 101.193C26.3121 102.6 23.9995 103.274 22.0082 104.284C21.893 104.13 21.7769 103.977 21.6617 103.823C22.4123 103.02 23.1531 102.209 23.9143 101.415C32.23 92.7545 40.6667 84.1963 48.812 75.3921C52.3045 71.6175 55.4756 67.504 58.2921 63.2423C62.6675 56.621 62.123 49.843 58.0544 43.1456C54.9831 38.0896 50.998 33.7403 46.9327 29.4445C38.7127 20.759 30.4456 12.1138 22.2005 3.44931C22.0642 3.3058 21.9644 3.13127 21.8475 2.97148L21.8459 2.9707Z"
            fill="#96ea6355"
            style={{ opacity: getOpacity(2) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M21.8459 2.9707C24.4847 3.79682 27.0611 4.66405 29.0532 6.54589C33.8107 11.0411 38.4822 15.6223 43.312 20.0453C48.7235 25.0013 54.2674 29.8261 59.7617 34.6998C63.9561 38.4208 67.9322 42.3109 70.5962 47.2397C72.8463 51.4021 72.8138 55.5505 70.5069 59.6804C68.2624 63.6977 65.2576 67.155 61.822 70.274C55.7052 75.8273 49.5212 81.3138 43.4248 86.8879C38.2339 91.6336 33.224 96.564 27.9237 101.193C26.3121 102.6 23.9995 103.274 22.0082 104.284C21.893 104.13 21.7769 103.977 21.6617 103.823C22.4123 103.02 23.1531 102.209 23.9143 101.415C32.23 92.7545 40.6667 84.1963 48.812 75.3921C52.3045 71.6175 55.4756 67.504 58.2921 63.2423C62.6675 56.621 62.123 49.843 58.0544 43.1456C54.9831 38.0896 50.998 33.7403 46.9327 29.4445C38.7127 20.759 30.4456 12.1138 22.2005 3.44931C22.0642 3.3058 21.9644 3.13127 21.8475 2.97148L21.8459 2.9707Z"
            fill="url(#paint2_linear_570_3148)"
            style={{ opacity: getOpacity(2) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M38.7001 96.0448C41.8055 93.2763 44.7673 90.3395 48.0463 87.7735C55.1644 82.2017 62.478 76.8579 69.6439 71.3412C72.8556 68.8682 76.1103 66.3907 78.9569 63.5578C80.8727 61.6512 82.3114 59.2201 83.5927 56.8411C85.132 53.9834 84.5396 51.0707 82.8445 48.3728C80.7185 44.99 77.9969 42.0834 74.7828 39.6284C66.9279 33.6291 58.9619 27.7602 51.1785 21.6787C47.467 18.7784 44.0662 15.5151 40.5331 12.4068C40.2613 12.1679 40.0625 11.8522 39.8296 11.5722C39.9051 11.4869 39.9797 11.4008 40.0552 11.3154C41.575 12.2695 43.1614 13.1422 44.6033 14.194C49.1353 17.4993 53.4603 21.0853 58.1472 24.1703C65.3537 28.9129 72.7736 33.3623 80.1465 37.8706C84.2824 40.3994 88.2739 43.0756 91.6552 46.5158C96.1701 51.1087 96.2091 55.8148 91.6309 60.3782C87.4949 64.5003 82.5849 67.6589 77.4857 70.5833C66.3429 76.9735 55.7015 84.0448 45.6728 91.9607C43.5898 93.6052 41.231 94.9309 38.9995 96.4032C38.8997 96.2829 38.7999 96.1635 38.7001 96.0432L38.7001 96.0448Z"
            fill="#96ea6355"
            style={{ opacity: getOpacity(3) / 100 }}
          />
          <path
            className="transition-all duration-700"
            d="M38.7001 96.0448C41.8055 93.2763 44.7673 90.3395 48.0463 87.7735C55.1644 82.2017 62.478 76.8579 69.6439 71.3412C72.8556 68.8682 76.1103 66.3907 78.9569 63.5578C80.8727 61.6512 82.3114 59.2201 83.5927 56.8411C85.132 53.9834 84.5396 51.0707 82.8445 48.3728C80.7185 44.99 77.9969 42.0834 74.7828 39.6284C66.9279 33.6291 58.9619 27.7602 51.1785 21.6787C47.467 18.7784 44.0662 15.5151 40.5331 12.4068C40.2613 12.1679 40.0625 11.8522 39.8296 11.5722C39.9051 11.4869 39.9797 11.4008 40.0552 11.3154C41.575 12.2695 43.1614 13.1422 44.6033 14.194C49.1353 17.4993 53.4603 21.0853 58.1472 24.1703C65.3537 28.9129 72.7736 33.3623 80.1465 37.8706C84.2824 40.3994 88.2739 43.0756 91.6552 46.5158C96.1701 51.1087 96.2091 55.8148 91.6309 60.3782C87.4949 64.5003 82.5849 67.6589 77.4857 70.5833C66.3429 76.9735 55.7015 84.0448 45.6728 91.9607C43.5898 93.6052 41.231 94.9309 38.9995 96.4032C38.8997 96.2829 38.7999 96.1635 38.7001 96.0432L38.7001 96.0448Z"
            fill="url(#paint3_linear_570_3148)"
            style={{ opacity: getOpacity(3) / 100 }}
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_570_3148"
            x1="25.5166"
            y1="53.4376"
            x2="0.000204698"
            y2="53.4376"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#96EA63" />
            <stop offset="1" stopColor="#408019" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_570_3148"
            x1="49.6047"
            y1="53.3937"
            x2="8.23935"
            y2="53.3937"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#96EA63" />
            <stop offset="1" stopColor="#408019" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_570_3148"
            x1="72.2607"
            y1="53.6272"
            x2="21.6617"
            y2="53.6272"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#96EA63" />
            <stop offset="1" stopColor="#408019" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_570_3148"
            x1="95.053"
            y1="53.8593"
            x2="38.7001"
            y2="53.8593"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#96EA63" />
            <stop offset="1" stopColor="#408019" />
          </linearGradient>
          <clipPath id="clip0_570_3148">
            <rect
              width="106.787"
              height="95.053"
              fill="#96ea6355"
              transform="translate(95.053) rotate(90)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default AnimatedLogo;
